module.exports = __webpack_public_path__ + "images/spider-man_rgba(0,0,0,0.7).aa931f171040e196bae2a2b22fccd671.jpg";